import axionIns from "../axios";

const getleadsProfile = (params) => {
  return axionIns.get(`user/ai${params}`).then((response) => {
    return response.data;
  });
};

const getAiAPI = (payload) => {
  return axionIns.get(`user/ai${payload}`).then((response) => {
    return response.data;
  });
};

const addCampaign = (payload) => {
  return axionIns.post("peopleai/campaign", payload).then((response) => {
    return response.data;
  });
};

const getGoals = (type = "advisor", companyId) => {
  return axionIns.get(`user/goals/${type}/${companyId}`).then((response) => {
    return response.data;
  });
};

const getSingleCampaignDetail = (campaignId) => {
  return axionIns.get(`auth/campaign/${campaignId}`).then((response) => {
    return response.data;
  });
};


const getProfileVisit = (campaignId) => {
  return axionIns.get(`auth/campaign/${campaignId}/visit`).then((response) => {
    return response.data;
  });
};


const getPublicCompany = (campaignId) => {
  return axionIns.get(`auth/company/${campaignId}`).then((response) => {
    return response.data;
  });
};

const getProfileByTrackingId = (trackingId) => {
  return axionIns.get(`auth/profileBytracking/${trackingId}`).then((response) => {
    return response.data;
  });
};


const getCampaignUpdate = (page, limit, campaignId) => {
  return axionIns.get(`auth/campaign/updates?page=${page}&perPage=${limit}&campaignid=${campaignId}`).then((response) => {
    return response.data;
  });
};

const getProfileById = (id) => {
  return axionIns.get(`auth/campaign/campaignprofile/${id}`).then((response) => {
    return response.data;
  });
};


const exportObject = {
  getleadsProfile,
  getAiAPI,
  addCampaign,
  getGoals,
  getSingleCampaignDetail,
  getProfileVisit,
  getPublicCompany,
  getProfileByTrackingId,
  getCampaignUpdate,
  getProfileById,
};
export default exportObject;
